import { enUS } from './en-US/index.js';
import { esES } from './es-ES/index.js';
import { ptBR } from './pt-BR/index.js';
export const resources = {
    'pt-BR': ptBR,
    'en-US': enUS,
    'es-ES': esES,
};
//# sourceMappingURL=index.js.map